// @ts-nocheck
import { CASE_CLOSE_ERROR, CASE_CLOSE_LOADING, CASE_CLOSE_SUCCESS } from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const CaseCloseReducer = (state = initialState, action) => {
    switch (action.type) {
        case CASE_CLOSE_LOADING:
            return Object.assign({}, state, { loading: true })
        case CASE_CLOSE_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CASE_CLOSE_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}
